import React from 'react';
import Container from '../../../containers/integration/menuItems/showMenuContainer';

export default function () {
  return (
    <Container />
  );
}
